
export const passingScores = {
  'math': 80,
  'langauge': 80,
  'reading': 80
};

export const schoolDistrictColors = {
    'CVESD': '#054fb9',
    'EUSD': '#054fb9',
    'SBUSD': '#238CA4',
    'YMCA-SD': '#238CA4'
  };
  
export const schoolDistrictColorsID = {
    1: '#054fb9',
    2: '#054fb9',
    3: '#238CA4',
    4: '#238CA4'
  };

export const schoolDistrictLogos = {
    'CVESD': "/images/CVESD_logo.png",
    'EUSD': "/images/EUSD-logo.png",
    'SBUSD': "/images/SBUSD-logo.png",
    'YMCA-SD': "/images/ymcasd-logo.png"
  }

export const questionNumberMap = {
    'language': 20,
    'math': 40,
    'reading': 28,
};

export const colorTheme = {
  light: {
      background:'#FFFFFF',
      background_grey:"#EFEFEF",
      background_dark_grey:'#C3C3C3',
      text: "#000000",
      text_dark_grey:"#343132",
      text_light_grey:"#656062",
      xlight:'#B3C7F7',
      light:'#8BABF1',
      main:'#0073E6',
      dark:'#0461CF',
      xdark:'#054FB9',
      error:'#C44601',
      error_light:'#fa9990',
      success:"#00BF7D",
      success_light:'#B9E192'
  }

}